<template>
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="128.000000pt"
    height="128.000000pt"
    viewBox="0 0 128.000000 128.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M390 1061 l-115 -129 3 -69 3 -68 -136 -150 c-74 -82 -134 -157 -133
-165 7 -37 46 -6 178 140 l139 155 1 72 0 72 105 117 c101 111 120 145 85 151
-9 2 -65 -53 -130 -126z"
      />
      <path
        d="M876 1124 c-4 -16 -18 -30 -36 -37 -37 -14 -38 -22 -2 -39 15 -7 31
-23 37 -36 13 -29 31 -28 39 2 4 15 17 28 36 34 38 14 38 23 -3 42 -20 9 -33
24 -35 38 -5 30 -28 28 -36 -4z m52 -68 c-10 -5 -21 -18 -24 -30 l-7 -21 -10
22 c-5 13 -18 25 -27 28 -16 5 -15 9 8 33 l27 27 25 -25 c23 -23 23 -26 8 -34z"
      />
      <path
        d="M525 1101 c-6 -11 83 -87 92 -77 7 7 -42 62 -69 77 -10 5 -19 5 -23
0z"
      />
      <path
        d="M497 1063 c-6 -10 82 -87 90 -79 3 3 -2 15 -13 27 -28 31 -72 60 -77
52z"
      />
      <path
        d="M682 1058 c-20 -20 -14 -66 9 -79 33 -17 69 3 69 39 0 33 -16 52 -45
52 -12 0 -26 -5 -33 -12z m62 -24 c7 -19 -10 -44 -29 -44 -19 0 -38 28 -31 45
7 20 52 19 60 -1z"
      />
      <path
        d="M465 1030 c-4 -6 -3 -15 1 -18 5 -4 25 -22 45 -40 53 -48 57 -24 5
27 -29 29 -46 39 -51 31z"
      />
      <path
        d="M430 992 c0 -14 79 -86 87 -79 4 4 -11 25 -32 47 -38 39 -55 49 -55
32z"
      />
      <path
        d="M918 969 c-24 -14 -23 -56 2 -69 42 -22 82 34 48 68 -14 14 -27 15
-50 1z m40 -32 c2 -12 -3 -17 -17 -17 -12 0 -21 6 -21 13 0 31 32 34 38 4z"
      />
      <path
        d="M400 952 c0 -10 73 -82 83 -82 19 0 3 28 -33 58 -40 33 -50 38 -50
24z"
      />
      <path
        d="M759 911 c-21 -17 -22 -21 -10 -50 16 -37 33 -38 85 -7 l39 24 -26
26 c-31 31 -56 33 -88 7z m71 -11 c12 -7 12 -12 -4 -29 -25 -27 -53 -27 -61 0
-11 33 30 51 65 29z"
      />
      <path
        d="M595 896 c-34 -15 -61 -61 -44 -72 17 -10 134 -17 163 -10 25 6 26 8
12 34 -8 16 -21 34 -29 40 -23 19 -70 23 -102 8z m93 -22 c28 -20 28 -44 0
-45 -41 -3 -103 3 -117 10 -10 6 -6 13 14 29 33 26 72 28 103 6z"
      />
      <path
        d="M880 841 c8 -5 26 -12 40 -15 24 -7 24 -6 6 8 -11 9 -29 16 -40 16
-17 -1 -18 -2 -6 -9z"
      />
      <path
        d="M432 810 c-37 -9 -77 -42 -98 -82 -27 -53 -11 -155 51 -313 22 -56
29 -92 33 -180 5 -126 12 -145 51 -145 51 0 91 64 91 148 0 65 28 109 75 118
77 14 125 -34 125 -126 0 -105 73 -178 122 -122 12 13 17 51 21 151 l5 133
-39 17 c-21 9 -39 19 -39 23 0 3 17 15 38 25 24 12 43 31 55 56 17 37 36 42
38 9 2 -39 29 77 30 129 2 132 -74 182 -223 148 -100 -22 -127 -23 -198 -5
-89 22 -103 24 -138 16z m98 -35 c72 -19 185 -19 264 1 61 15 65 15 103 -5 51
-25 77 -82 68 -145 -5 -34 -12 -44 -34 -53 -20 -7 -30 -19 -34 -42 -5 -26 -15
-35 -52 -51 -41 -18 -46 -23 -43 -47 2 -21 13 -32 42 -46 38 -18 38 -19 32
-64 -3 -25 -6 -79 -6 -120 0 -84 -15 -102 -53 -64 -17 16 -23 38 -28 98 -6 74
-7 78 -48 116 -40 37 -46 39 -88 34 -35 -4 -54 -13 -81 -40 -31 -31 -35 -42
-41 -104 -7 -76 -32 -126 -59 -121 -14 3 -18 21 -24 108 -5 89 -14 128 -53
245 -65 193 -59 262 30 301 38 17 39 17 105 -1z"
      />
      <path
        d="M914 455 l-21 -23 25 -25 25 -25 23 26 23 27 -21 23 c-26 26 -27 26
-54 -3z m46 -10 c10 -11 9 -17 -3 -29 -13 -13 -17 -13 -31 3 -12 13 -13 20 -4
29 16 16 23 15 38 -3z"
      />
    </g>
  </svg>
</template>

<script>
export default {}
</script>

<style></style>
